import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AbstractGridApiHandlerService, GridEngineFacade } from '@iot-platform/grid-engine';
import { ApiHelpers } from '@iot-platform/iot-platform-utils';
import { CommonApiListResponse, CommonApiRequest, CommonApiRequestBody } from '@iot-platform/models/common';
import { I4BBasicColumn, I4bCellConcept } from '@iot-platform/models/grid-engine';
import { Device } from '@iot-platform/models/i4b';
import { get } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevicesCustomGridApiHandlerService extends AbstractGridApiHandlerService {
  private readonly gridEngineFacade = inject(GridEngineFacade);
  selectedGrid = this.gridEngineFacade.selectedGrid;

  loadGridData(request: CommonApiRequest): Observable<CommonApiListResponse<Device>> {
    const params: HttpParams = this.getRequestHeader(request);
    const body: CommonApiRequestBody = this.getRequestBody(request);
    return this.http.post<CommonApiListResponse<Device>>(`${this.environment.api.url}${this.environment.api.endpoints.devices}/search`, body, { params });
  }

  getRequestHeader(request: CommonApiRequest): HttpParams {
    return ApiHelpers.getHttpParams({
      ...request,
      limit: -1,
      filters: [],
      variables: [],
      tags: []
    });
  }

  getRequestBody(request: CommonApiRequest): CommonApiRequestBody {
    const body = ApiHelpers.getHttpRequestBody(request);

    // Handle custom connectivity module fields
    // returnedFields on demand based on grid column definition
    const grid = this.selectedGrid();
    const connectivityFields = get(grid, 'columns', [])
      .filter((col: I4BBasicColumn) => col.configuration.concept === I4bCellConcept.CONNECTIVITY_MODULE)
      .map((col: I4BBasicColumn) => col.configuration.id);

    if (connectivityFields.length > 0) {
      body.returnedFields = connectivityFields;
    }

    return body;
  }
}
